<div *ngIf="!tableDisplay; else tableRowDisplay" class="card d-flex flex-column justify-content-between h-100" style="min-height: 200px; box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3); border: none;">
  <ng-container *ngIf="file.fileType == 'image'; else notImage">
    <div *ngIf="disableImgPreview">
      <img src="/assets/image-icon-placeholder.png" class="card-img-top pointer-cursor" style="object-fit: contain; padding: 50px;" (click)="viewFile()" title="Click to view image" />
    </div>
    <div *ngIf="!disableImgPreview">
      <img [src]="file.fileUrl" *ngIf="!file.loading" class="card-img-top pointer-cursor" (click)="viewFile()" title="Click to view image" />
      <div *ngIf="file.loading" class="card-img-top pointer-cursor"></div>
    </div>
  </ng-container>
  <ng-template #notImage>
    <img src="/assets/document-icon-blue.png" class="card-img-top pointer-cursor" style="object-fit: contain; padding: 50px;" (click)="downloadFile()" title="Click to download file" />
  </ng-template>
  <app-loading-indicator *ngIf="file.loading && !disableImgPreview"></app-loading-indicator>
  <div class="card-body pt-2 d-flex flex-column">
    <div *ngIf="!file.loading && file.error" class="text-danger">Failed to load image</div>
    <div *ngIf="!file.loading && !file.error" class="d-flex justify-content-between flex-wrap">
      <app-loading-indicator *ngIf="file.downloading" [small]="true"></app-loading-indicator>
      <button class="btn btn-sm btn-dark mt-2" *ngIf="!file.downloading" title="Download file" (click)="downloadFile()">Download</button>
      <ng-container [ngSwitch]="storageType">
        <ng-container *ngSwitchCase="'well'">
          <div class="d-flex justify-content-end align-items-center mt-2">
            <button *ngIf="!disableEdit" class="btn btn-sm btn-outline-dark d-flex align-items-center" (click)="editFile()" title="Edit file properties"><i class="far fa-edit pr-2"></i>Edit</button>
            <button *ngIf="!disableEdit" class="ml-1 btn btn-sm btn-outline-danger d-flex align-items-center" title="Delete file" (click)="deleteFile()"><i class="fas fa-trash-alt pr-2"></i>Delete</button>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div>
      <p class="mb-0 mt-3" style="font-size: 1.1em;">{{file.description}}</p>
      <p class="card-subtitle text-muted" style="padding-top: 5px; font-size: 0.9em;">{{file.fileName}}</p>
      <div class="text-right">
        <span class="badge badge-success" style="font-size: 85%" *ngIf="file.isAttachment">Distribute</span>
      </div>
    </div>
  </div>
</div>
<ng-template #tableRowDisplay>
  <div *ngIf="!file.loading && !file.error" class="d-flex justify-content-end">
    <app-loading-indicator *ngIf="file.downloading" [small]="true"></app-loading-indicator>
    <button class="btn btn-sm btn-dark" *ngIf="!file.downloading" title="Download file" (click)="downloadFile()">Download</button>
    <ng-container [ngSwitch]="storageType">
      <ng-container *ngSwitchCase="'well'">
        <button *ngIf="!disableEdit" class="ml-2 btn btn-sm btn-outline-dark" (click)="editFile()" title="Edit file properties">Edit</button>
        <button *ngIf="!disableEdit" class="ml-2 btn btn-sm btn-outline-danger" title="Delete file" (click)="deleteFile()">Delete</button>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- View File Modal -->
<p-dialog id="darkModal" [modal]="true" [(visible)]="viewFileModalVisible" [style]="{ width: '95vw' }" *ngIf="file">
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-between align-items-center text-white" style="font-size: 0.95rem; width: 100%;">
      <p-button label="Download" severity="contrast" [loading]="file.downloading" (onClick)="downloadFile()" [disabled]="file.downloading" />
      <div class="d-none d-md-block text-center">
        <p class="mb-0 text-dark"><strong>{{file.description}}</strong></p>
        <p class="card-subtitle text-muted mb-0" style="padding-top: 5px; font-size: 0.9em;">{{file.fileName}}</p>
      </div>
      <div style="width: 5px;"></div>
    </div>
  </ng-template>
  <div class="px-2 pt-2" style="font-size: 0.95rem;">
    <div class="d-flex justify-content-center">
      <img [src]="file.fileUrl" *ngIf="!file.loading" style="max-width: 100%; max-height: 80vh;">
      <app-loading-indicator *ngIf="file.loading"></app-loading-indicator>
    </div>
  </div>
</p-dialog>

<!-- Edit File Data Modal -->
<p-dialog header="Edit File" [modal]="true" [(visible)]="editFileDataModalVisible" [style]="{ width: '95vw' }" *ngIf="editForm">
  <div class="d-flex flex-column-reverse flex-lg-row justify-content-center align-items-center justify-content-lg-between pt-2" style="font-size: 0.95rem;">
    <div class="px-2 flex-fill text-center">
      <div class="">
        <ng-container *ngIf="file.fileType == 'image'; else notImage">
          <img [src]="file.fileUrl" *ngIf="!file.loading" style="max-width: 100%; max-height: 60vh;" />
          <app-loading-indicator *ngIf="file.loading"></app-loading-indicator>
        </ng-container>
        <ng-template #notImage>
          <img src="/assets/document-icon-blue.png" style="max-width: 100%; max-height: 60vh; padding-top: 5em; padding-bottom: 5em; " />
        </ng-template>
      </div>
    </div>
    <div class="px-2 flex-fill text-left">
      <ng-container [formGroup]="editForm">
        <div class="pt-4 pt-lg-0 pl-0 pl-lg-4" style="width: 100%">
          <div class="form-group rr-form-group">
            <label for="field">File</label>
            <p>{{file.fileName}}</p>
          </div>
          <div class="form-group rr-form-group">
            <label for="field">Short Description</label>
            <input class="form-control rr-form-control" type="text" trim="blur" formControlName="description" maxlength="500" placeholder="Ex: Tool damaged while pulling out of hole" />
          </div>
          <div class="form-group rr-form-group" *ngIf="storageType == 'jobsheet'">
            <label>Distribute File With Report <span><i class="pl-2 fas fa-question-circle" pTooltip="Choose whether or not to include the file as an attachment with the distributed report email." tooltipPosition="right"></i></span></label>
            <span class="pl-2"></span>
            <div class="d-block btn-group" role="button">
              <button style="width: 75px" *ngIf="editForm.controls['isAttachment'].value" class="btn btn-success btn-sm" type="button">Yes</button>
              <button style="width: 75px" *ngIf="!editForm.controls['isAttachment'].value" (click)="handleToggleIsAttachment(true)" class="btn btn-outline-secondary btn-sm" type="button">Yes</button>
              <button style="width: 75px" *ngIf="editForm.controls['isAttachment'].value" (click)="handleToggleIsAttachment(false)" class="btn btn-outline-secondary btn-sm" type="button">No</button>
              <button style="width: 75px" *ngIf="!editForm.controls['isAttachment'].value" class="btn btn-danger btn-sm" type="button">No</button>
            </div>
          </div>
          <div class="text-center text-danger pt-2">
            <strong>{{errorEditMessage}}</strong>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <hr />
  <div class="px-2">
    <div class="d-flex justify-content-center">
      <p-button label="Cancel" severity="secondary" (onClick)="editFileDataModalVisible = false" />
      <span class="px-1"></span>
      <p-button label="Update File" severity="contrast" [loading]="editing" (onClick)="onSubmitFileEdit()" [disabled]="!editForm.valid || !editForm.dirty || editing" />
    </div>
  </div>
</p-dialog>

<!-- Delete file confirmation -->
<p-dialog header="Delete Confirmation" [modal]="true" [(visible)]="deleteFileModalVisible" [style]="{ width: '30rem' }">
  <div class="px-2 pt-2" style="font-size: 0.95rem;">
    <p>Are you sure you want to delete the <em>{{file.fileName}}</em> file?</p>
    <div class="text-center text-danger pt-2">
      <strong>{{errorDeleteMessage}}</strong>
    </div>
  </div>
  <hr />
  <div class="px-2">
    <div class="d-flex justify-content-end">
      <p-button label="No" severity="secondary" (onClick)="deleteFileModalVisible = false" />
      <span class="px-1"></span>
      <p-button label="Yes" severity="danger" [loading]="deleting" (onClick)="confirmDelete()" />
    </div>
  </div>
</p-dialog>
<!------>
<!-- Toast Message -->
<p-toast position="bottom-center"></p-toast>
